appSocial.controller('leaderFundsPage', [
    '$scope', '$state', '$ionicModal', '$filter', 'SocialLocaleService', 'SocialUtils', 'trader', 'SocialActionService', 'SocialTypes',
    function ($scope, $state, $ionicModal, $filter, SocialLocaleService, SocialUtils, trader, SocialActionService, SocialTypes) {
        class LeaderFundsPage {
            constructor() {
                this.translation = SocialLocaleService.translation;
                this.$scope = $scope;
                this.$state = $state;

                /**
                 * @type {SocialUtils}
                 */
                this.utils = SocialUtils;

                /**
                 * @type {SocialActionService}
                 */
                this.actionService = SocialActionService;

                this.actions = SocialTypes.CopyAction;

                this.trader = trader;
                this.action = $state.params.action;

                this.currencyPipe = $filter('cryptoCurrency');

                this.modal = {
                    isError: false,
                    textTitle: '',
                    textContent: '',
                    state: false,
                    isProcess: false
                }

                this.validationError = null;
            }

            callAction() {
                // send to children component event
                this.$scope.$broadcast(this.action);
            }

            onSuccess(amount) {
                this.modal.isProcess = false;

                this.modal.textTitle = (this.action === this.actions.SetStopLoss)
                    ? this.translation.stopLossUpdated
                    : ((this.action === this.actions.AddFunds)
                        ? this.translation.fundsAdded
                        : this.translation.fundsRemoved);

                this.modal.textContent = (this.action === this.actions.SetStopLoss)
                    ? this.translation.stopLossUpdatedSuccessfully
                    : ((this.action === this.actions.AddFunds)
                        ? this.utils.renderTranslation(this.translation.successfullyAdded, {
                            amount: this.currencyPipe(amount, 'USD'),
                            fullName: this.trader.fullname
                        })
                        : this.utils.renderTranslation(this.translation.successfullyRemoved, {
                            amount: this.currencyPipe(amount, 'USD'),
                            fullName: this.trader.fullname
                        }))

                this.modal.actionText = this.translation.continue;

                this.modal.back = {
                    state: 'root.app.socialPortfolio',
                    params: {category: 'current', id: this.trader.id}
                }
            }

            onFail(error) {
                this.modal.isError = true;
                this.modal.state = true;
                this.modal.isProcess = false;
                this.modal.textTitle = (this.action === this.actions.SetStopLoss)
                    ? this.translation.stopLossFailed
                    : ((this.action === this.actions.AddFunds)
                        ? this.translation.failedAddFunds
                        : this.translation.failedRemoveFunds);

                this.modal.textContent = this.translation.messages[error.data.type] || 'Something went wrong';

                this.modal.actionText = this.translation.continue;
            }

            onActionStart() {
                this.modal.isError = false;
                this.modal.state = true;
                this.modal.isProcess = true;
                this.modal.textTitle =
                    (this.action === this.actions.SetStopLoss)
                        ? this.translation.stopLossProcessing
                        : ((this.action === this.actions.AddFunds)
                            ? this.translation.addingFundsProcessing
                            : this.translation.removingFundsProcessing);
            }

            onValidation(error) {
                this.validationError = error;
            }

            deposit() {
                return this.utils.navigate('root.app.wallet');
            }
        }

        return new LeaderFundsPage()
    }]);

